import { gql } from '@apollo/client';

export const SEND_SINGLE_STRIPE_TRANSACTION = gql`
mutation sendSingleStripeTransaction($token : String!,$paymentdata:CustomerPayment!) {
  sendSingleStripeTransaction(token: $token, paymentdata:$paymentdata) {
    status
    data
    error
  }
}
`;

export const SEND_STRIPE_VERIFICATION_TRANSACTIONS = gql`
mutation sendStripeVerificationTransactions($phone : String!) {
  sendStripeVerificationTransactions(phone: $phone) {
    status
    data
    error
  }
}
`;

export const CONIFRM_STRIPE_VERIFICATION_TRANSACTIONS = gql`
mutation verifyTempStripeTransactions($phone : String!, $amount1 : Float!) {
  verifyTempStripeTransactions(phone: $phone, amount1: $amount1) {
    status
    data
    error
  }
}
`;